import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapTimeline = React.lazy(function () {
    return import('../../bootstrap-components/components/BTTimeline');
});
var bootStrapTimeline = function (props) {
    return (React.createElement(BootStrapTimeline, { styleName: props.styleName, ioTheme: props.ioTheme, ioMode: props.ioMode, displayType: props.displayType, value: props.value, cardHeight: props.cardHeight, flipLayout: props.flipLayout, borderLessCards: props.borderLessCards, isMode: props.isMode, hideControls: props.hideControls, cardPositionHorizontal: props.cardPositionHorizontal, scrollable: props.scrollable, componentTheme: props.componentTheme }));
};
export var Timeline = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapTimeline(props);
        default:
            componentToDisplay = bootStrapTimeline(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
Timeline.defaultProps = {
    styleName: 'primary',
    // label: 'TextBox',
    ioTheme: themes[0],
    ioMode: 'light'
};
//# sourceMappingURL=Timeline.js.map